import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { flagLinks } from './constants';

import styles from './styles/index.module.scss';

const Flags = memo(({ platform }) => (
  <div className={styles.group}>
    {flagLinks
      .filter(flag => flag.value !== platform)
      .map(({ value, href, dataQa, name, FlagId }) => (
        <a
          key={value}
          className={styles.flag}
          href={href}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={name}
          data-qa={dataQa}
        >
          <FlagId width={24} height={24} />
        </a>
      ))}
  </div>
));

Flags.propTypes = {
  platform: PropTypes.string.isRequired,
};

Flags.displayName = 'Flags';

export default Flags;
